import { IPageData, IPageParams } from "../types";

/**
 * 操作状态
 * $t('enum.E_OperatorStatus.Normal')
 * $t('enum.E_OperatorStatus.Exception')
 */
export enum E_OperatorStatus {
    /**
     * 正常
     */
    Normal = 0,
    /**
     * 异常
     */
    Exception = 1,
    /**
     * 处理中
     */
    Processing = 2,
}

export enum E_AuditRiskLevel {
    /**
     * 低风险
     */
    Low = 1,
    /**
     * 中风险
     */
    Medium = 2,
    /**
     * 高风险
     */
    High = 3,
}

/**
 * 登录类型
 * $t('enum.E_LoginType.WEB')
 * $t('enum.E_LoginType.APP')
 * $t('enum.E_LoginType.PAD')
 */
export enum E_LoginType {
    WEB = 'WEB',
    APP = 'APP',
    PAD = 'PAD',
}

/**
 * 登录账号活跃度
 * $t('enum.E_LoginAccountActivity.High')
 * $t('enum.E_LoginAccountActivity.Medium')
 * $t('enum.E_LoginAccountActivity.Low')
 */
export enum E_LoginAccountActivity {
    High = 'HIGH',
    Medium = 'MEDIUM',
    Low = 'LOW',
}

/**
 * 登录账号状态
 * $t('enum.E_LoginAccountStatus.Normal')
 * $t('enum.E_LoginAccountStatus.TempLocked')
 * $t('enum.E_LoginAccountStatus.Disabled')
 * $t('enum.E_LoginAccountStatus.Expired')
 * $t('enum.E_LoginAccountStatus.CompanyDisabled')
 * $t('enum.E_LoginAccountStatus.NoPermission')
 */
export enum E_LoginAccountStatus {
    Normal = 'NORMAL',
    TempLocked = 'TEMP_LOCKED',
    Disabled = 'DISABLED',
    Expired = 'EXPIRED',
    CompanyDisabled = 'COMPANY_DISABLED',
    NoPermission = 'NO_PERMISSION',
}

/**
 * 登录认证方式
 * $t('enum.E_LoginAuthType.Password')
 * $t('enum.E_LoginAuthType.AutoLogin')
 */
export enum E_LoginAuthType {
    Password = 'PASSWORD',
    AutoLogin = 'AUTO_LOGIN',
}

/**
 * 登录结果
 * $t('enum.E_LoginStatus.Success')
 * $t('enum.E_LoginStatus.Failure')
 * $t('enum.E_LoginStatus.Blocked')
 */
export enum E_LoginStatus {
    /**
     * 成功
     */
    Success = 0,
    /**
     * 失败
     */
    Failure = 1,
    /**
     * 已拦截
     */
    Blocked = 2,
}

export interface IMonitorFilterOption {
    value: string | number
    label: string
}

/**
 * 操作日志模块
 */
export enum E_AuditLogModule {
    Export = 'EXPORT',
    Query = 'QUERY',
    PersonalSetting = 'PERSONAL_SETTING',
    NonKeyRemark = 'NON_KEY_REMARK',
    TagGroup = 'TAG_GROUP',
    AlarmRemark = 'ALARM_REMARK',
    NoticeDraft = 'NOTICE_DRAFT',
    UserManagement = 'USER_MANAGEMENT',
    CustomerManagement = 'CUSTOMER_MANAGEMENT',
    EquipmentManagement = 'EQUIPMENT_MANAGEMENT',
    PointManagement = 'POINT_MANAGEMENT',
    SensorManagement = 'SENSOR_MANAGEMENT',
    GatewayManagement = 'GATEWAY_MANAGEMENT',
    BearingCaseLibrary = 'BEARING_CASE_LIBRARY',
    AlarmHandle = 'ALARM_HANDLE',
    DiagnosisExecute = 'DIAGNOSIS_EXECUTE',
    DataExport = 'DATA_EXPORT',
    InspectionManagement = 'INSPECTION_MANAGEMENT',
    NoticeAppVersion = 'NOTICE_APP_VERSION',
    DataRuleCaptureCard = 'DATA_RULE_CAPTURE_CARD',
    UserRolePermission = 'USER_ROLE_PERMISSION',
    CustomerDeletePermission = 'CUSTOMER_DELETE_PERMISSION',
    CoreObjectDelete = 'CORE_OBJECT_DELETE',
    BatchOperation = 'BATCH_OPERATION',
    ThresholdWarning = 'THRESHOLD_WARNING',
    AlarmConfig = 'ALARM_CONFIG',
    FirmwareUpgrade = 'FIRMWARE_UPGRADE',
    DiagnosisConfig = 'DIAGNOSIS_CONFIG',
    DataMaintenance = 'DATA_MAINTENANCE',
    OpenApi = 'OPEN_API',
    PushConfig = 'PUSH_CONFIG',
    LargeScreen = 'LARGE_SCREEN',
    SecurityConfig = 'SECURITY_CONFIG',
    AuditLog = 'AUDIT_LOG',
    LoginLog = 'LOGIN_LOG',
}

/**
 * 业务操作类型
 * $t('enum.E_BusinessType.Other')
 * $t('enum.E_BusinessType.Insert')
 * $t('enum.E_BusinessType.Update')
 * $t('enum.E_BusinessType.Delete')
 * $t('enum.E_BusinessType.Grant')
 * $t('enum.E_BusinessType.Export')
 * $t('enum.E_BusinessType.Import')
 * $t('enum.E_BusinessType.Force')
 * $t('enum.E_BusinessType.Gencode')
 * $t('enum.E_BusinessType.Clean')
 * $t('enum.E_BusinessType.Execute')
 * $t('enum.E_BusinessType.Publish')
 * $t('enum.E_BusinessType.Upgrade')
 * $t('enum.E_BusinessType.Rollback')
 * $t('enum.E_BusinessType.Upload')
 * $t('enum.E_BusinessType.Close')
 * $t('enum.E_BusinessType.Query')
 */
export enum E_BusinessType {
    /**
     * 其它/其他
     */
    Other = 0,
    /**
     * 新增
     */
    Insert = 1,
    /**
     * 修改
     */
    Update = 2,
    /**
     * 删除
     */
    Delete = 3,
    /**
     * 授权
     */
    Grant = 4,
    /**
     * 导出
     */
    Export = 5,
    /**
     * 导入
     */
    Import = 6,
    /**
     * 强退/强制
     */
    Force = 7,
    /**
     * 生成代码
     */
    Gencode = 8,
    /**
     * 清空数据/清理初始化
     */
    Clean = 9,
    /**
     * 执行或处理
     */
    Execute = 10,
    /**
     * 发布
     */
    Publish = 11,
    /**
     * 升级
     */
    Upgrade = 12,
    /**
     * 回滚
     */
    Rollback = 13,
    /**
     * 上传
     */
    Upload = 14,
    /**
     * 关闭或停用
     */
    Close = 15,
    /**
     * 查询
     */
    Query = 16,
}

/**
 * 操作人类别
 * $t('enum.E_OperatorType.Other')
 * $t('enum.E_OperatorType.Backend')
 * $t('enum.E_OperatorType.Mobile')
 */
export enum E_OperatorType {
    /**
     * 其它
     */
    Other = 0,
    /**
     * 后台用户
     */
    Backend = 1,
    /**
     * 手机端用户
     */
    Mobile = 2,
}

export interface IOperlogListParams extends IPageParams {
    moduleCode?: E_AuditLogModule
    operName?: string
    companyId?: number
    businessType?: E_BusinessType
    riskLevel?: E_AuditRiskLevel
    status?: E_OperatorStatus
    beginTime?: string
    endTime?: string
}

export interface IOperlogListItem {
    companyId: number
    id: number
    logNo: string
    moduleCode: string
    moduleName: string
    title: string
    businessType: E_BusinessType
    businessTypeName: string
    /**
     * 操作人员
     */
    operName: string
    /**
     * 主机地址
     */
    operIp: string
    riskLevel: E_AuditRiskLevel
    riskLevelName: string
    /**
     * 操作状态
     */
    status: E_OperatorStatus
    statusName: string
    parentCompanyId: number
    summary: string
    targetId: string
    targetName: string
    targetType: string
    /**
     * 操作时间
     */
    operTime: string
}

export type IOperlogListData = IPageData<IOperlogListItem>

export interface IOperlogDetailData extends IOperlogListItem {
    afterData: string
    asyncFlag: number
    baseRiskLevel: E_AuditRiskLevel
    baseRiskLevelName: string
    beforeData: string
    changedFields: string
    deptName: string
    durationMs: number
    errorMsg: string
    finishTime: string
    jsonResult: string
    method: string
    operLocation: string
    operParam: string
    operUrl: string
    operatorId: number
    parentCompanyId: number
    requestId: string
    requestMethod: string
    requestTime: string
    riskContext: string
    riskReason: string
    riskRuleCode: string
    //是否敏感操作:1敏感操作0不是敏感操作
    sensitiveFlag: number
    userAgent: string
}

export interface IAuditLogQueryParams {
    beginTime?: string
    businessType?: E_BusinessType
    companyId?: number
    endTime?: string
    moduleCode?: E_AuditLogModule
    operName?: string
    riskLevel?: E_AuditRiskLevel
    status?: E_OperatorStatus
}

export interface IOperlogFilterOptionsData {
    businessTypes: IMonitorFilterOption[]
    modules: IMonitorFilterOption[]
    operators: IMonitorFilterOption[]
    riskLevels: IMonitorFilterOption[]
    statuses: IMonitorFilterOption[]
}

export interface IOperlogStatisticsData {
    dataExportCount: number
    failureCount: number
    highRiskCount: number
    sensitiveOperationCount: number
    todayOperationCount: number
}


export interface IOperlogLoginListParams extends IPageParams {
    beginTime?: string
    companyId?: number
    endTime?: string
    ipaddr?: string
    loginType?: E_LoginType
    status?: E_LoginStatus
    userName?: string
}

export interface IOperlogLoginListItem {
    companyId: number
    id: number
    ipaddr: string
    logNo: string
    loginTime: string
    loginType: E_LoginType
    loginTypeName: string
    parentCompanyId: number
    status: E_LoginStatus
    statusName: string
    terminalEnvironment: string
    userName: string
}

export type IOperlogLoginListData = IPageData<IOperlogLoginListItem>

export interface IOperlogLoginDetailData extends IOperlogLoginListItem {
    accountActivity: E_LoginAccountActivity
    accountActivityName: string
    accountStatus: E_LoginAccountStatus
    accountStatusName: string
    authType: E_LoginAuthType
    authTypeName: string
    browser: string
    failureCount: number
    failureReason: string
    loginLocation: string
    msg: string
    os: string
    userAgent: string
    userId: number
}

export interface ILoginLogQueryParams {
    beginTime?: string
    companyId?: number
    endTime?: string
    ipaddr?: string
    loginType?: E_LoginType
    status?: E_LoginStatus
    userName?: string
}

export interface IOperlogLoginFilterOptionsData {
    loginResults: IMonitorFilterOption[]
    loginTypes: IMonitorFilterOption[]
}

export interface IOperlogLoginStatisticsData {
    blockedCount: number
    failureCount: number
    successCount: number
    totalCount: number
}
